import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field } from '@simonbackx/simple-encoding';
import { STCredit } from './STCredit.js';
import { STInvoice } from './STInvoice.js';
import { STPackage } from './STPackage.js';
import { OrganizationPaymentMandate } from './OrganizationPaymentMandate.js';
import { STPendingInvoice } from './STPendingInvoice.js';
export class STBillingStatus extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.mandates = [];
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(STInvoice) })
], STBillingStatus.prototype, "invoices", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(STPackage) })
], STBillingStatus.prototype, "packages", void 0);
__decorate([
    field({ decoder: STPendingInvoice, nullable: true })
], STBillingStatus.prototype, "pendingInvoice", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(STCredit) })
], STBillingStatus.prototype, "credits", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(OrganizationPaymentMandate), optional: true })
], STBillingStatus.prototype, "mandates", void 0);
//# sourceMappingURL=STBillingStatus.js.map